<br /><br /><br />

<!-- CARROUSEL -->
<section id="carrousel">
  <div
    id="carouselExampleIndicators"
    class="carousel slide"
    data-ride="carousel"
  >
    <ol class="carousel-indicators">
      <li
        data-target="#carouselExampleIndicators"
        data-slide-to="0"
        class="active"
      ></li>
      <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
      <!-- <li data-target="#carouselExampleIndicators" data-slide-to="2"></li> -->
    </ol>
    <div class="carousel-inner">
      <div class="carousel-item active">
        <img
          src="./assets/img/fundoCursoView.svg"
          class="d-block w-100"
          alt="..."
        />
      </div>
      <div class="carousel-item">
        <img
          src="./assets/img/fundoCursoII.svg"
          class="d-block w-100"
          alt="..."
        />
      </div>
      <!-- <div class="carousel-item">
            <img src="./assets/img/fundoCursoView.svg" class="d-block w-100" alt="...">
        </div> -->
    </div>
    <button
      class="carousel-control-prev"
      type="button"
      data-target="#carouselExampleIndicators"
      data-slide="prev"
    >
      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      <span class="sr-only">Previous</span>
    </button>
    <button
      class="carousel-control-next"
      type="button"
      data-target="#carouselExampleIndicators"
      data-slide="next"
    >
      <span class="carousel-control-next-icon" aria-hidden="true"></span>
      <span class="sr-only">Next</span>
    </button>
  </div>
</section>

<!-- DESTAQUES -->
<section id="destaques">
  <div class="container">
    <div class="row">
      <div class="col-12 text-center mt-5">
        <h2 class="font-prof">Aprenda com os melhores!</h2>
      </div>
    </div>
    <div class="d-flex justify-content-between mt-4 mb-5 row">
      <div
        class="col-md-3 col-sm-12 p-4 rounded-pill text-center threed"
        *ngFor="let e of destaques"
      >
        <h1 class="p-0 font-prof">{{ e.dadoNumber }}</h1>
        <h5 class="p-0 font-lato corCurso text-uppercase">{{ e.dadoText }}</h5>
      </div>
    </div>
    <br />
  </div>
</section>

<div class="col-12 text-center mb-4 mt-4">
  <a
    class="btn btn-primar corblue text-white font-lato-btn w-50 shadow grow"
    href="#"
    >INSCREVER AGORA</a
  >
</div>
<br /><br /><br />
<!-- OQUE VAI APRENDER -->
<section id="topicos">
  <div class="container mt-5">
    <div class="row">
      <ul class="col-md-8 col-sm-12 mt-3">
        <h4 class="mb-3">Oque você vai aprender</h4>
        <li class="ml-4" *ngFor="let lista of listaAssuntos">
          {{ lista.desc }}
        </li>
      </ul>
      <div class="col-md-4 text-center">
        <img
          src="./assets/img/vetorTopicos.svg"
          class="d-block w-100"
          alt="..."
        />
      </div>
    </div>
  </div>
</section>

<br /><br /><br /><br />

<!-- AVALIACOES -->
<section id="avaliacoes">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h4 class="mb-0">Avaliações</h4>
        <span
          class="float-right text-primary"
          (click)="abrirAvaliacoes()"
          type="button"
          >Todas avaliações</span
        >

        <hr class="mt-0" />
      </div>
      <div
        class="col-12 form-inline mb-3"
        *ngFor="let avaGeral of avaliacoesGeral"
      >
        <p class="letraAvaliacao">
          {{ avaGeral.avaliacaoGeral }} <i class="fas fa-star text-warning"></i>
        </p>
        <span class="ml-4"
          >{{ avaGeral.totalAvaliacoes }} <span>Avaliações</span></span
        >
      </div>

      <div
        class="col-md-6 col-sm-12 mb-3"
        *ngFor="let cardaval of cardAvaliacoes"
      >
        <div class="card rounded-lg border-0 shadow">
          <div class="row">
            <div class="col-4 my-auto">
              <img
                src="{{ cardaval.imagem }}"
                class="img-fluid rounded-circle"
                alt=""
              />
            </div>
            <div class="col-8">
              <h5 class="mt-2">
                {{ cardaval.nomeCli
                }}<span class="float-right mr-3 small">
                  <i class="fas fa-star text-warning"></i>
                  {{ cardaval.avaliacao }}</span
                >
              </h5>

              <p class="small mt-4">{{ cardaval.comentarioAval }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<br /><br /><br /><br />
<!-- INVISTA EM VOCE -->
<section id="invista">
  <div class="corBlueDark pt-4 pb-4">
    <div class="container">
      <div class="row">
        <h1
          class="size-invista p-0 text-white mx-auto mb-0 mt-2 font-montserrat"
        >
          Invista <br />
          em <br />
          <span class="corCurso">você</span>!
        </h1>
        <ul class="mx-auto mt-3 w-60 p-2">
          <h4 class="text-white" *ngFor="let benef of beneficiosCurso">
            <i class="fas fa-check mr-2 corCurso my-auto"></i>
            {{ benef.beneficio }}
          </h4>
          <hr class="bg-white" />
          <h4 class="text-white">
            Curso completo por <span class="corCurso">R$ 399,90</span>
          </h4>
          <a
            class="btn btn-primary mt-3 corblue text-white font-lato-btn grow w-100 shadow mx-auto"
            href="#"
            >INSCREVER AGORA</a
          >
        </ul>
      </div>
    </div>
  </div>
</section>

<br /><br /><br /><br />
<!-- CONHECA QUEM CRIOU -->
<section id="criador">
  <div class="container">
    <div class="row" *ngFor="let tutor of criadorCurso">
      <div class="col-12">
        <h4 class="mb-0">Conheça quem criou</h4>
        <hr class="mt-0" />
      </div>
      <div class="col-2 p-0 text-center">
        <img
          src="./assets/img/sem-imagem.png"
          class="shadow rounded-circle w-75"
          alt=""
        />
      </div>
      <div class="col-10">
        <h5 class="mt-2">{{ tutor.nomeCriador }}</h5>
        <p>{{ tutor.descricaoCR }}</p>
      </div>
      <div class="col-12 mt-2">
        <a href=""> <i class="fab fa-instagram fa-2x m-2 ml-3"></i> </a>
        <a href=""><i class="fab fa-facebook fa-2x m-2"></i></a>
        <a href=""><i class="fab fa-youtube fa-2x m-2"></i></a>
      </div>
    </div>
  </div>
</section>

<br /><br /><br /><br /><br />
<!-- PERGUNTAS FREQUENTES -->
<section id="faq">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h4 class="mb-0">Perguntas perguntas</h4>
        <hr class="mt-0" />
      </div>
    </div>
    <div
      class="accordion w-100 mb-3"
      [id]="'a' + i"
      *ngFor="let faq of perguntasFreq; let i = index; as: i"
    >
      <div class="card">
        <div class="card-header" id="headingOne">
          <h2 class="mb-0">
            <button
              class="btn btn-link btn-block text-left text-dark font-weight-bold collapsed"
              type="button"
              data-toggle="collapse"
              [attr.data-target]="'#e' + i"
              aria-expanded="false"
              aria-hidden="false"
              aria-controls="collapseOne"
            >
              {{ faq.tituloFaq }}
            </button>
          </h2>
        </div>

        <div
          [id]="'e' + i"
          class="collapse"
          aria-labelledby="headingOne"
          [attr.data-parent]="'#a' + i"
        >
          <div class="card-body">
            {{ faq.resposta }}
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<br /><br /><br /><br /><br />

<!-- OUTROS PRODUTOS -->
<section id="outrosProdutos">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h4 class="mb-0">Outros produtos deste autor</h4>
        <hr class="mt-0" />
      </div>
      <div class="col-md-4 col-sm-6 mb-3" *ngFor="let outros of outrosProdutos">
        <div class="card shadow">
          <div class="card-body p-0">
            <img
              src="{{ outros.imagem }}"
              class="img-fluid"
              alt="Imagem curso"
            />
            <div class="m-3 mt-0">
              <span class="small"
                >{{ outros.avaliacao
                }}<span> <i class="fas fa-star text-warning"></i> </span
              ></span>
              <h5 class="">{{ outros.nomeCurso }}</h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- TODAS AVALIACOES -->
<ng-template #modalTodasAvaliacoes>
  <div class="modal-header p-1 m-0">
    <h5 class="my-auto ml-2">Avaliações</h5>
    <button
      type="button"
      class="close cardM mr-2 float-right my-auto"
      (click)="decline()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body mt-0">
    <div class="">
      <label for="">Filtros:</label>
      <p>
        <i class="fas fa-star text-warning fa-2x"></i
        ><i class="fas fa-star text-warning fa-2x"></i
        ><i class="fas fa-star text-warning fa-2x"></i
        ><i class="fas fa-star text-warning fa-2x"></i
        ><i class="fas fa-star text-warning fa-2x"></i>
      </p>
    </div>
    <div class="row mt-5 mb-3">
      <div
        class="col-md-6 col-sm-12 mb-3"
        *ngFor="let cardaval of cardAvaliacoes"
      >
        <div class="card rounded-lg border-0 shadow">
          <div class="row">
            <div class="col-4 my-auto">
              <img
                src="{{ cardaval.imagem }}"
                class="img-fluid rounded-circle"
                alt=""
              />
            </div>
            <div class="col-8">
              <h5 class="mt-2">
                {{ cardaval.nomeCli
                }}<span class="float-right mr-3 small">
                  <i class="fas fa-star text-warning"></i>
                  {{ cardaval.avaliacao }}</span
                >
              </h5>

              <p class="small mt-4">{{ cardaval.comentarioAval }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-center">
      <nav aria-label="Page navigation example">
        <ul class="pagination">
          <li class="page-item">
            <a class="page-link" href="#" aria-label="Previous">
              <span aria-hidden="true">&laquo;</span>
            </a>
          </li>
          <li class="page-item"><a class="page-link" href="#">1</a></li>
          <li class="page-item"><a class="page-link" href="#">2</a></li>
          <li class="page-item"><a class="page-link" href="#">3</a></li>
          <li class="page-item">
            <a class="page-link" href="#" aria-label="Next">
              <span aria-hidden="true">&raquo;</span>
            </a>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</ng-template>
